<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="배출구별 주요배출시설 가동(조업)시간"
        tableId="table"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" icon="save" v-if="!param.isFullScreen" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'daily-air-report-01',
  props: {
    param: {
      type: Object,
      default: () => ({
        reportId: '',
        isFullScreen: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [
          {
            name: 'col0',
            field: 'col0',
            label: '배출구',
            align: 'left',
            sortable: false,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '배출시설',
            align: 'left',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '가동시간(시)',
            align: 'center',
            type: 'number',
            style: 'width:140px',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '가동시간(분)',
            align: 'center',
            type: 'number',
            style: 'width:140px',
            sortable: false,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '비고',
            align: 'left',
            type: 'text',
            sortable: false,
          },
        ],
        height: '600px',
        data: [],
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
    if (this.param.isFullScreen) {
      this.grid.height = 'auto';
    }
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.grid.data = [
        {
          col0: '드라이1호기',
          col1: '혼합시설 외 3개',
          col2: '24',
          col3: '0',
          col4: '',
        },
        {
          col0: '흡수에의한 시설',
          col1: '유무기산저장시설 외 10개',
          col2: '24',
          col3: '0',
          col4: '',
        },
        {
          col0: '드라이3호기',
          col1: '건조시설',
          col2: '24',
          col3: '0',
          col4: '',
        },
        {
          col0: 'Bag Filter',
          col1: '포장시설',
          col2: '24',
          col3: '0',
          col4: '',
        },
        {
          col0: 'A/C Tower',
          col1: '혼합시설 외 10개',
          col2: '24',
          col3: '0',
          col4: '',
        },
      ]
    },
  }
};
</script>
